export * from './tenant-item.component';
